import { defaultPagination } from 'constants/defaultPagination';
import { PaginationQueries } from 'types/search.type';
import { useForm } from './useForm';

export function usePagination() {
  const [pagination, paginationDispatch] =
    useForm<PaginationQueries>(defaultPagination);

  const incrementPage = () => {
    paginationDispatch({ type: 'page', payload: pagination.page + 1 });
  };

  return {
    pagination,
    paginationDispatch,
    incrementPage,
  };
}
